const REDIRECT_DELAY = 7000;

export default class ThanksRedirect {
    constructor($page) {
        const redirectUrl = $page.dataset.thanksRedirect;
        if ( ! redirectUrl) {
            return;
        }

        const startRedirect = () => {
            window.setTimeout(() => window.location.replace(redirectUrl), REDIRECT_DELAY);
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', startRedirect, {once: true});
            return;
        }

        startRedirect();
    }
}
